package io.horion.auth.presentation.ui.pages.navigation

sealed class Screen(val route: String) {
    data object Login: Screen(route = "/")
    data object Register: Screen(route = "/register")
    data object Confirm: Screen(route = "/confirm")
    data object RefreshToken: Screen(route = "/refresh")
    data object Verify: Screen(route = "/verify")
    data object ResetPassword: Screen(route = "/reset-password")
    data object ForgetPassword: Screen(route = "/forget-password")
    data object Profile: Screen(route = "/profile")
    data object Logout: Screen(route = "/logout")
}
